import * as React from 'react';

import DateFormat from '@core/components/display/datetime/DateFormat';
import { classNames } from '@core/utils/functions/class-names';
import Link from 'next/link';

import { Author } from '@/types/ArticleType';

type ByLineProps = {
    authors: Author[];
    publishedAtTimestamp: number;
    className?: string;
};

const ByLine = (props: ByLineProps) => {
    const { publishedAtTimestamp, authors, className } = props;

    return (
        <div className={classNames('flex flex-wrap justify-start items-start gap-1', className)}>
            {authors.length > 0 && (
                <div className="flex gap-1 uppercase">
                    by{' '}
                    {authors.map((author, index) => (
                        <span key={author.id}>
                            {author.id ? (
                                <Link href={`/author/${author.slug}`} passHref>
                                    <a className="link-gray">{author.title}</a>
                                </Link>
                            ) : (
                                <span className="link-gray">{author.title}</span>
                            )}
                            {index !== authors.length - 1 && '&'}
                        </span>
                    ))}
                    <span> /</span>
                </div>
            )}
            <div className="flex justify-start items-start relative gap-2 uppercase">
                <DateFormat dateStringOrTimestamp={publishedAtTimestamp} format="LLLL d, yyyy" />{' '}
            </div>
        </div>
    );
};

export default ByLine;
